import type { OtpChannel, OtpDetails } from 'ehs-react';
import type { at } from '../generated/Beans';

type LoginResponse = at.sense.hooks.login.LoginResponse;

export function getAllAvailableOtpDetails(
  loginResponse: LoginResponse
): OtpDetails[] {
  const plainTwoFactorMethods =
    loginResponse.twoFactorAuthenticationMethods || [];
  return plainTwoFactorMethods.map(stringValue => {
    const otpChannel = stringValue as OtpChannel;
    return {
      sendMethod: otpChannel,
      recipient: determineRecipient(loginResponse, otpChannel)
    };
  });
}

export function getUniqueOtpDetails(
  loginResponse: LoginResponse
): OtpDetails | undefined {
  const twoFactorMethods = getAllAvailableOtpDetails(loginResponse);
  if (twoFactorMethods.length !== 1) {
    console.log('unable to uniquely determine the current input method');
    return undefined;
  }
  return twoFactorMethods[0];
}

export function getMainLoginButton(): HTMLButtonElement | undefined {
  const loginBtn = document.querySelector(
    '.sign-in-form > .input-container > .button-holder > .btn-primary:not(.nextStep)'
  );
  if (!loginBtn) {
    return undefined;
  }
  return loginBtn as HTMLButtonElement;
}

function determineRecipient(
  loginResponse: LoginResponse,
  otpChannel: OtpChannel
): string {
  if (otpChannel === 'SMS' && loginResponse.phoneNumber) {
    return loginResponse.phoneNumber;
  }
  if (otpChannel === 'EMAIL' && loginResponse.emailAddress) {
    return loginResponse.emailAddress;
  }
  return '******';
}
